import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getContactActivity } from "../actions/contactAction";
import { Get_Guest_Activity, getEventDetails } from "../actions/eventAction";
import { getTodayComments, insertGuestUser } from "../actions/userAction";
import Header from "../components/Header";
import OthersRecentComments from "../components/OthersRecentComments";
import SelfPastComments from "../components/SelfPastComments";
import SelfTodayComments from "../components/SelfTodayComments";
import Spinner, { ButtonSpinner } from "../components/Spinner";
import { GUEST_USER_COMMENT_INSERT_RESET } from "../constants/userConstants";
import { todayDate } from "../core/common";
import axios from "axios";

export default function GuestActivity(props) {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [contactId, setContactId] = useState(0);
  const [contactId2, setContactId2] = useState(0);
  const [comment, setComment] = useState("");
  const guestCrm = JSON.parse(localStorage.getItem("guestCrm"));
  const eventName = useSelector((state) => state.eventName);
  const { loading, eventTitle, error } = eventName;

  const contactActivity = useSelector((state) => state.contactActivity);
  const {
    loading: contactLoading,
    error: contactError,
    activityRec,
  } = contactActivity;

  const guestUserInsert = useSelector((state) => state.guestUserInsert);

  const {
    attendedCount,
    loading: loadingAtend,
    error: errorAtend,
  } = useSelector((s) => s.AttendedStuentCountReducer);
  const {
    loading: insertLoading,
    error: insertError,
    success: insertSuccess,
  } = guestUserInsert;

  const guestTodayComments = useSelector((state) => state.guestTodayComments);
  const { todayComments } = guestTodayComments;

  const guestUserLogin = useSelector((state) => state.guestUserLogin);
  const { userInfo } = guestUserLogin;

  //----- /guestactivity/guest/getUniversity/:eventId
  //   console.log(attendedCount, "user");

  const handleCommentSubmit = (e) => {
    e.preventDefault();
    dispatch(
      insertGuestUser({
        Contact_Id: parseInt(contactId),
        Event_Id: id,
        Comment: comment,
      })
    );

    dispatch(
      getTodayComments({
        Contact_Id: parseInt(contactId),
        Event_Id: "0",
        TodayDate: todayDate,
        Guest_Id: "0",
        Past: false,
      })
    );
  };

  useEffect(() => {
    if (userInfo == undefined || userInfo == "" || userInfo == null) {
      if (guestCrm) {
        navigate(`/login`);
      } else {
        navigate(`/login`);
      }
    } else {
      if (eventTitle == undefined || eventTitle == "") {
        dispatch(getEventDetails(id));
      }
      if ((activityRec == undefined || activityRec == "") && contactId != 0) {
        dispatch(
          getContactActivity({
            ContactId: contactId,
          })
        );
      }
      if (insertSuccess != undefined || insertSuccess != "") {
        setComment("");
        setTimeout(() => {
          dispatch({
            type: GUEST_USER_COMMENT_INSERT_RESET,
          });
        }, 5000);
      }
    }
  }, [dispatch, eventTitle, activityRec, insertSuccess]);

  //   const [contactId2, setContactId2] = useState(0);

  //   const guestTodayComments = useSelector((state) => state.guestTodayComments);
  //   const { loading, error, todayComments } = guestTodayComments;

  //   useEffect(() => {
  //     // if (dataa == undefined || dataa.length == 0) {
  //     if (
  //       todayComments == undefined ||
  //       todayComments.length == 0 ||
  //       contactId2 !== props.contactId
  //     ) {
  //       dispatch(getTodayComments(props.commentJson));
  //       setContactId2(props.contactId);
  //     }
  //   }, [todayComments, props.contactId]);

  useEffect(() => {
    dispatch(Get_Guest_Activity(id));
  }, [id]);

  return (
    <Header>
      <div style={{ height: "76vh" }} className="student-information-body">
        <div className="row">
          <div class="col-md-12 text-center event-title">
            {!loading ? (
              <>
                <h3>{eventTitle}</h3>
              </>
            ) : (
              <Spinner />
            )}
          </div>
          <div className="col-md-8 student-info-tabel Left_Student_Det">
            <div className="row  mb-3">
              <div className="col-md-9">
                <h3>Guest Information</h3>
              </div>
              {/* <div className="col-md-3">
                <form onSubmit={handleSubmit}>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Student Id. "
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      value={contactId}
                      onChange={(e) => handleCheck(e)}
                    />
                    <div className="input-group-prepend">
                      <button className="input-group-text" id="basic-addon1">
                        <i
                          className="fa fa-search"
                          aria-hidden="true"
                          onClick={handleSubmit}
                        ></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div> */}
            </div>
            <hr />
            {contactLoading ? (
              <Spinner />
            ) : (
              <>
                {attendedCount ? (
                  <>
                    {attendedCount != "" ? (
                      <table className="Table_Guest">
                        <thead>
                          <th>Guest Id</th>
                          <th>Guest Name</th>
                          <th>University</th>
                          <th>Expected Students</th>
                          <th>Attended</th>
                        </thead>
                        <tbody>
                          {attendedCount?.map((ev) => (
                            <tr>
                              <td>{ev?.Id}</td>
                              <td>{ev?.Guest_Name}</td>
                              <td>{ev?.University_Name}</td>
                              <td style={{ color: "blue", fontWeight: "bold" }}>
                                {ev?.Match_Count}
                              </td>
                              <td style={{ color: "blue", fontWeight: "bold" }}>
                                {ev?.Attended_Count}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <>No Record Exist!</>
                    )}
                  </>
                ) : (
                  <>
                    {errorAtend ? <>{errorAtend}</> : <div>{errorAtend}</div>}
                  </>
                )}
              </>
            )}
          </div>

          <div className="col-md-4 Left_Student_Det">
            <div className="leave-comments">
              <div className="custom-comments">
                <div className="d-flex justify-content-center row">
                  <div className="col-md-12">
                    <div className="d-flex flex-column comment-section">
                      <div className="bg-light p-3 mt-2">
                        {/* <div className="d-flex flex-row align-items-start">
                          <img
                            className="rounded-circle"
                            src="/assets/img/Deafult-user.png"
                            alt=""
                            width="40"
                          />
                          <textarea
                            className="form-control ml-1 shadow-none textarea"
                            rows="6"
                            placeholder="Write your comment..."
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                          ></textarea>
                        </div> */}
                        <div className="mt-3 text-right">
                          {insertLoading ? (
                            <ButtonSpinner />
                          ) : (
                            <>
                              <button
                                className="btn get-call btn-sm shadow-none mb-2"
                                type="button"
                                onClick={(e) => (window.location.href = "/126")}
                              >
                                Go Back
                              </button>

                              {/* <button
                                className="btn btn-outline-dark btn-sm ml-1 shadow-none mb-2"
                                type="button"
                                onClick={(e) => setComment("")}
                              >
                                Clear
                              </button> */}

                              <br />
                            </>
                          )}
                          <span className="text-sed-success">
                            {insertSuccess}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="commentAccordion" id="accordionComment">
                  <div className="card">
                    <div
                      className="card-header"
                      data-toggle="collapse"
                      data-target="#collapseOne"
                      aria-expanded="true"
                    >
                      <span className="title">Today </span>
                      <span className="accicon">
                        <i className="fas fa-angle-down rotate-icon"></i>
                      </span>
                    </div>
                    <div
                      id="collapseOne"
                      className="collapse show"
                      data-parent="#accordionComment"
                    >
                      <SelfTodayComments
                        contactId={contactId2}
                        todayComments={todayComments}
                        commentJson={{
                          Contact_Id: contactId2,
                          Event_Id: "0",
                          TodayDate: todayDate,
                          Guest_Id: "0",
                          Past: false,
                        }}
                      />
                      {/* <div className="card-body">
                                                <div className="comment-content bg-white p-2">
                                                    <div className="d-flex flex-row user-info">
                                                        <img className="rounded-circle" src="assets/img/Deafult-user.png" alt="" width="40" />
                                                        <div className="d-flex flex-column justify-content-start ml-2"><span className="d-block font-weight-bold name">Marry Andrews</span><span className="date text-black-50">Lorem ipsum dolor - May 2022</span></div>
                                                    </div>
                                                    <div className="mt-2">
                                                        <p className="comment-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                                                    </div>
                                                </div>
                                            </div> */}
                    </div>
                  </div>
                  <div className="card">
                    <div
                      className="card-header collapsed"
                      data-toggle="collapse"
                      data-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                    >
                      <span className="title">Past Comments</span>
                      <span className="accicon">
                        <i className="fas fa-angle-down rotate-icon"></i>
                      </span>
                    </div>
                    <div
                      id="collapseTwo"
                      className="collapse"
                      data-parent="#accordionComment"
                    >
                      <SelfPastComments
                        contactId={contactId2}
                        commentJson={{
                          Contact_Id: parseInt(contactId2),
                          Event_Id: "0",
                          TodayDate: todayDate,
                          Guest_Id: "0",
                          Past: true,
                        }}
                      />
                    </div>
                  </div>
                  <div className="card">
                    <div
                      className="card-header collapsed"
                      data-toggle="collapse"
                      data-target="#collapseThree"
                      aria-expanded="false"
                    >
                      <span className="title">Recent Activity</span>
                      <span className="accicon">
                        <i className="fas fa-angle-down rotate-icon"></i>
                      </span>
                    </div>
                    <div
                      id="collapseThree"
                      className="collapse"
                      data-parent="#accordionComment"
                    >
                      <OthersRecentComments
                        contactId={contactId2}
                        commentJson={{
                          Contact_Id: parseInt(contactId2),
                          Event_Id: "0",
                          TodayDate: todayDate,
                          Guest_Id: "1",
                          Past: false,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Header>
  );
}
